module.exports = __webpack_public_path__ + "static/media/1000860.3c55005d.png";